export default __webpack_public_path__ + "static/avatar-big-1e07927127447a161e97c280b0f509d3.jpg";